import { render, staticRenderFns } from "./customer-importer-page.vue?vue&type=template&id=f0a68fea&"
import script from "./customer-importer-page.vue?vue&type=script&lang=js&"
export * from "./customer-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports